// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1f4b92f","455":"9bdf4e72","833":"e5156e49","977":"4727a09c"}[chunkId] + ".chunk.js";
};